import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'sand' | 'sage' | 'terracotta' | 'success' | 'warning' | 'error';
}

export function Badge({ className, variant = 'sand', children, ...props }: BadgeProps) {
  const variants = {
    sand: 'bg-sand-100 text-sand-700',
    sage: 'bg-sage-100 text-sage-700',
    terracotta: 'bg-terracotta-100 text-terracotta-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-amber-100 text-amber-700',
    error: 'bg-red-100 text-red-700',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-full',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
